import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface DeleteRequest {
    category: string;
    idx: number[];
}

interface DeleteResponse {
    statusCode: number;
    message: string;
    data: null;
}

export const useDeleteConsolePopup = (onSuccessCallback?: () => void): UseMutationResult<DeleteResponse, Error, DeleteRequest> => {
    const queryClient = useQueryClient();

    return useMutation<DeleteResponse, Error, DeleteRequest>({
        mutationFn: async (body: DeleteRequest) => {
            const url = enum_api_uri.delete_console_popup.replace(":category", body.category);
            const res = await axiosInstance.delete(url, {
                data: { idx: body.idx },
            });
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsolePopups"] });
            onSuccessCallback?.();
        },
    });
};
